import React, { Component } from 'react'
import { connect } from 'react-redux'
import TextareaField from 'components/Layout/New/TextareaField'
import InputField from 'components/Layout/New/InputField'

import { MAX_CTA_LENGTH } from 'config/constants'

class WelcomesForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      infoCharsRemaining: 200,
      ctaTextCharsRemaining: MAX_CTA_LENGTH,
    }
  }

  getCharsRemaining = event => {
    const field = event.target
    const charsRemaining = field.value
      ? field.maxLength - field.value.length
      : field.maxLength
    this.setState({ [`${field.name}CharsRemaining`]: charsRemaining })
  }

  render() {
    const { welcomeType } = this.props

    const hasCtaText = welcomeType.value !== 'no_cta' || !welcomeType

    return (
      <div className="WelcomesForm">
        <div className="row">
          <TextareaField
            label="Welcome Message"
            name="info"
            type="text"
            maxLength={200}
            getCharsRemaining={this.getCharsRemaining}
            charsRemaining={this.state.infoCharsRemaining}
          />

          {hasCtaText && (
            <InputField
              label="CTA Label"
              name="ctaText"
              type="text"
              maxLength={MAX_CTA_LENGTH}
              getCharsRemaining={this.getCharsRemaining}
              charsRemaining={this.state.ctaTextCharsRemaining}
            />
          )}
        </div>
        <div className="row">
          <InputField label="Priority" name="priority" type="number" />
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  const {
    welcome: { welcomeType },
  } = state

  return { welcomeType }
}

export default connect(mapStateToProps)(WelcomesForm)
